export default __webpack_public_path__ + "static/mcp-chat-dress-f4a3328722b30b8c77c8ed99131958a8.webp";